<!--
  <div class="footer-top">
    <h2>Stay in Touch</h2>
    <p>
      Sign up for our newsletter.
    </p>

    <div class="container">
      <div class="col-lg-4"></div>
      <div class="col-lg-4">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Enter your e-mail here">
          <span class="input-group-btn">
            <button class="btn btn-secondary" type="button">Sign up</button>
          </span>
        </div>
      </div>
      <div class="col-lg-4"></div>

    </div>


  </div>
-->
<div class="footer-bottom chrome-no-repaint d-flex align-items-center">
  <!--
  <div class="footer-socialmedia">
    <i class="fa fa-facebook" aria-hidden="true"></i>
    <i class="fa fa-twitter" aria-hidden="true"></i>
    <i class="fa fa-google-plus" aria-hidden="true"></i>
  </div>
  -->

  <div class="footer-copyright">© wedavinci 2021-{{ currYear }}</div>
  <div class="footer-nav">
    <a href="https://www.wedavinci.com/legal-notice-impressum/" target="_blank">
      Legal Notice / Impressum
    </a>
    <a href="https://www.wedavinci.com/datenschutzerklaerung/" target="_blank">
      Datenschutzerklärung
    </a>
    <a href="https://www.wedavinci.com/data-protection-policy/" target="_blank">
      Data Protection Policy
    </a>
  </div>
</div>
